export {
  customStyles,
  MenuList,
  LabeledCreatableSelect,
} from "./creatableSelectWidgets";

export { GoogleAutoComplete } from "../../../globals/components/forms/GoogleAutoCompleteField";

export const uploadToADLS = async (file) => {
  const { apiClient } = await import("../../../api/httpClient");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("file_name", file.name);

  const response = await apiClient(
    "/bond-file-upload/",
    "POST",
    formData,
    {},
    { "Content-Type": "multipart/form-data" }
  );

  if (!response.blob_link) {
    throw new Error("Blob link not returned from the server.");
  }

  return response.blob_link;
};
